<modal-form-container
  title="Numbers in this message"
  className="md:w-[600px]"
  [showModal]="open"
  (closeModalEvent)="closeModal()"
>
  @if (open) {
    <div class="sl">
      @if (phoneNumbers.length > 0) {
        <div class="sl__bar">
          <app-search-input
            class="sl__search"
            placeholder="Search numbers"
            [debounce]="150"
            (valueChange)="term = $event"
          />
          <p class="sl__count">{{ formatCount(phoneNumbers.length) }} {{ phoneNumbers.length === 1 ? "number" : "numbers" }}</p>
        </div>

        @if (shown.length) {
          <ul class="sl__list">
            @for (phoneNumber of shown; track phoneNumber) {
              <li class="sl__row">
                <span class="sl__text"><span class="sl__name">{{ phoneNumber }}</span></span>
                <button
                  type="button"
                  class="bk-icon-btn"
                  [attr.aria-label]="'Remove ' + phoneNumber"
                  matTooltip="Remove from message"
                  (click)="removePhoneNumber.emit(phoneNumber)"
                >
                  <span class="bk-sym" aria-hidden="true">close</span>
                </button>
              </li>
            }
          </ul>
        } @else {
          <p class="sl__empty">No numbers match “{{ term }}”.</p>
        }
      } @else {
        <p class="sl__empty">No numbers added. Type one in the Recipients section and choose Add number.</p>
      }

      <div class="sl__foot">
        <button type="button" class="bk-btn bk-btn--primary" (click)="closeModal()">Done</button>
      </div>
    </div>
  }
</modal-form-container>
